
import React from 'react';
import { Button } from '@/components/ui/button';
import { Loader2 } from 'lucide-react';
import { 
  Dialog, 
  DialogContent, 
  DialogHeader, 
  DialogTitle, 
  DialogFooter, 
  DialogDescription 
} from '@/components/ui/dialog';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';

interface CancelOrderDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  isPending: boolean;
  reason: string;
  onReasonChange: (reason: string) => void;
  title?: string;
  description?: string;
  cancelButtonText?: string;
  confirmButtonText?: string;
}

const CancelOrderDialog = ({ 
  open, 
  onOpenChange, 
  onConfirm, 
  isPending,
  reason,
  onReasonChange,
  title = "Anulo Porosinë",
  description = "A jeni të sigurt që dëshironi të anuloni këtë porosi? Ky veprim nuk mund të kthehet.",
  cancelButtonText = "Mbyll",
  confirmButtonText = "Anulo Porosinë"
}: CancelOrderDialogProps) => {
  // Generate unique ID for dialog description
  const dialogDescId = React.useId();

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent aria-describedby={dialogDescId}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription id={dialogDescId}>
            {description}
          </DialogDescription>
        </DialogHeader>

        <div className="py-4">
          <Label htmlFor="cancel-reason" className="mb-2 block">
            Arsyeja e anulimit:
          </Label>
          <Textarea
            id="cancel-reason"
            value={reason}
            onChange={(e) => onReasonChange(e.target.value)}
            placeholder="Ju lutemi shpjegoni pse dëshironi të anuloni këtë porosi..."
            className="resize-none"
            rows={4}
          />
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            {cancelButtonText}
          </Button>
          <Button 
            variant="destructive" 
            onClick={onConfirm}
            disabled={isPending || !reason.trim()}
          >
            {isPending ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Duke anuluar...
              </>
            ) : (
              confirmButtonText
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default CancelOrderDialog;
